export default __webpack_public_path__ + "static/media/view_Details.0a893dd7.svg";